export default "__VITE_ASSET__BVilXadi__"